import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { NumberInputBasic, Warning, MessagesNumberInputBasic } from '../../../../../utils/models/input.interface';
import { ControlContainer, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
  selector: 'number-input-basic-induxtry',
  templateUrl: './number-input-basic.component.html',
  styleUrls: ['./number-input-basic.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: NumberInputBasicComponent,
    },
  ],
})
export class NumberInputBasicComponent implements OnInit{
  @Input() numberInput: NumberInputBasic;
  @Input() warning: Warning;
  @Input() decimalPlace = 0;
  @Input() configCurrentMask;

  beforeWarning = false;
  messages: MessagesNumberInputBasic;

  @Input() formControlName: string;

  @Output() valueEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Output() errorEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() focusOutEmitter: EventEmitter<number> = new EventEmitter<number>();


  constructor(@Optional() private controlContainer: ControlContainer) {}

  writeValue(value: any): void {
    this.numberInput.value = value;
  }

  onChange: (_: any) => void = () => { }

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }


  ngOnInit(): void {
    if (!this.configCurrentMask) {
      this.configCurrentMask = {
        prefix: '',
        thousands: '.',
        decimal: ',',
        precision:
        this.decimalPlace,
        align: 'left',
        allowNegative: this.numberInput?.hasAllowNegative ? false : true
      }
    }
    if (this.numberInput.messages) {
      this.messages = this.numberInput.messages;
    } else {
      this.messages = {
        min: `Valor mínimo deve ser maior ou igual a %{min}`,
        max: `Valor máximo deve ser menor ou igual a %{max}`
      }
    }
    if(this.controlContainer) {
      const control = this.controlContainer.control.get(this.formControlName);
      if (control && control.hasValidator(Validators.required)) {
        if (this.numberInput && this.numberInput?.required) {
          this.numberInput.required.active = true;
        }
      }
    }
  }

  handleModelChangeNumberInputBasic(): void {
    let removeWarning = true;
    let error = false;
    if ((this.numberInput.min || this.numberInput.min === 0)) {
      if (this.numberInput.value < this.numberInput.min || this.numberInput.value === null || this.numberInput.value === undefined) {
        removeWarning = false;
        this.beforeWarning = true;
        this.warning = {
          status: 'error',
          text: this.messages.min.replace(new RegExp(`%{min}`, 'g'), `${this.numberInput.min}`)
        }
        error = true;
      }
    }
    if (this.numberInput.max) {
      if (this.numberInput.value > this.numberInput.max) {
        removeWarning = false;
        this.beforeWarning = true;
        this.warning = {
          status: 'error',
          text: this.messages.max.replace(new RegExp(`%{max}`, 'g'), `${this.numberInput.max}`)
        }
        error = true;
      }
    }
    if (removeWarning && this.beforeWarning) {
      this.warning = {status: '', text: ''};
      this.beforeWarning = false;
      error = false;
    }

    this.errorEmitter.emit({error: error, value: this.numberInput.value})
    this.onChange(this.numberInput.value);
    this.valueEmitter.emit(this.numberInput.value);
  }

  handleFocusOut(): void {
    this.focusOutEmitter.emit(this.numberInput.value);
  }

  // handleChangeNumberInputBasic(): void {
  //   // if (!this.beforeWarning) {
  //     // this.errorEmitter.emit({error: this.error, value: this.numberInput.value})
  //     this.onChange(this.numberInput.value);
  //     this.valueEmitter.emit(this.numberInput.value);
  //   // }
  // }
}
